module.exports = __webpack_public_path__ + "img/vuetify_logo.a1d6f016.svg";